export default "__VITE_ASSET__C$ec2SrL__"